import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { cloudChiprApi } from "@/services/cloudchipr.api";
import { addFilterTreePathToResourceExplorerPayload } from "@/store/resource-explorer/utils/helpers/addFilterTreePathToResourceExplorerPayload";
import { resourceExplorerPayloadDataSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/resource-explorer-widget/resourceExplorerPayloadDataSelector";
import { isExplainWithAiOutDateRangesSelector } from "@/store/explain-with-ai/selectors/isExplainWithAiOutDateRangesSelector";

export const getExplainWithAiAnomaliesSummaryThunkFixedCashKey =
  "getExplainWithAiAnomaliesSummaryThunk_fixed_cash_key";

export const getExplainWithAiAnomaliesSummaryThunk = createAsyncThunk(
  "resourceExplorer/getExplainWithAiAnomaliesCount",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;
    const resourceExplorerDataGettingPayload =
      resourceExplorerPayloadDataSelector(state);
    const isOutRangesDates = isExplainWithAiOutDateRangesSelector(state);
    const { postUsersMeOrganisationsCurrentResourceExplorerAnomaliesSummary } =
      cloudChiprApi.endpoints;

    if (!resourceExplorerDataGettingPayload.group_by || isOutRangesDates) {
      return;
    }

    const payload = addFilterTreePathToResourceExplorerPayload(
      resourceExplorerDataGettingPayload,
    );
    try {
      await dispatch(
        postUsersMeOrganisationsCurrentResourceExplorerAnomaliesSummary.initiate(
          { resourceExplorerFilterSchema: payload },
          {
            fixedCacheKey: getExplainWithAiAnomaliesSummaryThunkFixedCashKey,
          },
        ),
      );
    } catch (e) {}
  },
);
